import { ArrowRight, Facebook, Newspaper, Building2, Hotel, Tent, Award, GraduationCap } from "lucide-react";
import { IMAGES } from "../constants";

const CREDS = [
  { icon: <Award className="w-4 h-4" />, t: "深耕旅宿產業 15 年以上" },
  { icon: <Hotel className="w-4 h-4" />, t: "連鎖飯店集團經營管理出身" },
  { icon: <Building2 className="w-4 h-4" />, t: "宜蘭礁溪知名溫泉酒店總經理" },
  { icon: <Tent className="w-4 h-4" />, t: "自己經營奢華露營區與包棟民宿" },
];

const STATS = [
  { v: "170 位", l: "半年合作 KOL" },
  { v: "700 萬+", l: "社群曝光" },
  { v: "700 萬", l: "為 12 家旅宿帶來營收" },
  { v: "40%+", l: "平均營收成長" },
];

const CourseSection = () => (
  <section data-testid="founder-section" id="founder" className="py-14 md:py-32 bg-[#F8F9FA]">
    <div className="max-w-7xl mx-auto px-5 md:px-12">
      <div className="bg-gradient-to-br from-[#0A2540] to-[#163859] rounded-3xl p-6 md:p-12 overflow-hidden relative">
        <div className="absolute top-0 right-0 w-72 h-72 bg-[#FF6B00]/10 rounded-full blur-3xl"></div>

        <div className="relative z-10 mb-8 md:mb-10" data-testid="founder-photo">
          <img src={IMAGES.course} alt="旅宿達人貝瑞大叔 Berry 廖士鈞 — 180 天旅宿自媒體變現計畫" className="w-full h-auto rounded-2xl md:rounded-3xl shadow-2xl ring-4 ring-white/10 block" />
        </div>
        <div className="relative z-10">
            <div className="inline-flex items-center gap-2 bg-[#FF6B00] text-white px-4 py-2 rounded-full text-sm font-bold mb-5">
              <Building2 className="w-4 h-4" />
              不是紙上談兵的行銷公司
            </div>
            <h2 className="text-2xl md:text-4xl font-black text-white leading-tight mb-3">
              我們自己就在經營旅宿，<br className="hidden md:block" />
              每天用<span className="text-[#FF6B00]">同一套方法賣自己的房</span>
            </h2>
            <p className="text-white/75 text-sm md:text-base mb-6 leading-relaxed">
              人客多由<span className="text-white font-bold">旅宿達人貝瑞大叔</span>帶領，團隊出身飯店集團 — 您遇到的問題，我們每天也在自己的場域裡解決。
            </p>

            <div className="grid sm:grid-cols-2 gap-2.5 mb-6" data-testid="founder-creds">
              {CREDS.map((c) => (
                <div key={c.t} className="flex items-center gap-2.5 bg-white/10 rounded-xl px-3.5 py-2.5 text-white text-sm">
                  <span className="text-[#FF6B00] flex-shrink-0">{c.icon}</span>
                  <span className="font-semibold">{c.t}</span>
                </div>
              ))}
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 md:gap-3 mb-6" data-testid="founder-stats">
              {STATS.map((s) => (
                <div key={s.l} className="bg-white/5 border border-white/10 rounded-xl p-3 text-center">
                  <div className="text-lg md:text-xl font-black text-[#FF6B00]">{s.v}</div>
                  <div className="text-[11px] md:text-xs text-white/70 leading-snug">{s.l}</div>
                </div>
              ))}
            </div>

            <a
              href="https://money.udn.com/money/story/5635/9392524"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="founder-news-link"
              className="flex items-center justify-between gap-3 bg-white rounded-2xl px-4 py-3 mb-5 hover:shadow-lg transition-shadow"
            >
              <div className="flex items-center gap-3 min-w-0">
                <div className="w-10 h-10 bg-[#FF6B00]/10 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Newspaper className="w-5 h-5 text-[#FF6B00]" />
                </div>
                <div className="min-w-0">
                  <div className="text-[11px] text-[#FF6B00] font-bold">經濟日報報導</div>
                  <div className="text-sm font-bold text-[#0A2540] leading-snug">貝瑞大叔帶領網紅實現邊玩邊賺，用 180 天旅宿完成自媒體變現</div>
                </div>
              </div>
              <ArrowRight className="w-5 h-5 text-[#FF6B00] flex-shrink-0" />
            </a>

            <div className="flex flex-wrap gap-3">
              <a href="https://www.facebook.com/uncleberry01" target="_blank" rel="noopener noreferrer" data-testid="founder-fb-link"
                className="inline-flex items-center gap-2 bg-white/10 text-white hover:bg-white/20 transition-colors px-5 py-2.5 rounded-full font-bold text-sm">
                <Facebook className="w-4 h-4" />
                追蹤貝瑞大叔粉專
              </a>
              <a href="https://uncleberry.withwind.tw/" target="_blank" rel="noopener noreferrer" data-testid="founder-course-link"
                className="inline-flex items-center gap-2 text-white/70 hover:text-white transition-colors px-2 py-2.5 font-semibold text-sm">
                <GraduationCap className="w-4 h-4" />
                180 天旅宿自媒體變現課程（與有風造識合作）
                <ArrowRight className="w-4 h-4" />
              </a>
            </div>
          </div>
      </div>
    </div>
  </section>
);

export default CourseSection;
